<template>
  <div class="product">
    <img class="product-img" :src="imgPath" alt="product-img">
    <div class="info">
      <p>{{ name }}</p>
      <div class="renting">
        <p>Renting period:</p>
        <div class="total"><div class="progress" :style="{width: rent}"></div></div>
      </div>
    </div>
    <div class="settings">
      <button class="button-settings" style="background-color: rgb(81, 201, 131);">Extend Renting Period</button>
      <button class="button-settings" style="background-color: #C20000;">End Renting Period</button>
      <router-link to="/tickets" class="button-settings" style="background-color: #FF8C19;">Request Support</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MyDevice',
  props: {
    imgPath: String,
    name: String,
    price: Number,
    type: Number,
    rent: Number,
  },
  mounted() {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style scoped>
.info > * {
  margin: 0;
}

.renting > p {
  margin-top: 10px;
  margin-bottom: 0;
}

a {
  text-decoration: none;
  margin: 0;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-settings {
  width: 80%;
  height: 15%;
  border: none;
  cursor: pointer;
  color: white;
  font-size: 16px;
  font-weight: 600;
  border-radius: 0.25em;
}
.settings {
  background-color: rgba(0, 0, 0, 0.80);
  position: absolute;
  width: 250px;
  height: 250px;
  border-radius: 1em;
  display: none;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
}
p {
  text-align: center;
}
.product {
  width: 250px;
  height: 250px;
  background-color: transparent;
  border-radius: 1em;
  padding: 1em;
  margin: 0.7em;
  box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.product:hover > .settings {
  display: flex;
}

.product-img {
  width: 220px;
  max-height: 190px;
}
.renting {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.total {
  width: 150%;
  background-color: lightgray;
  height: 15px;
  border-radius: 1em;
}

.progress {
  width: 50%;
  height: 15px;
  background-color: rgb(81, 201, 131);
  border-radius: 1em;
}
</style>
